export default __webpack_public_path__ + "static/media/showcase.f677f40f.webm";